module.exports = __webpack_public_path__ + "../resources/img/ic_delete_gray950.294c70fc.svg";